type QuarantineLiteral =
  "集中隔离" | 
  "居家隔离" | 
  "其它";

type PseudoTypeQuarantine = {
  id: number,
  name: QuarantineLiteral,
}

const pseudoQuarantineMap: Array<PseudoTypeQuarantine> = [
  {
    id: 1,
    name: "集中隔离",
  },
  {
    id: 2,
    name: "居家隔离",
  },
  {
    id: 3,
    name: "其它",
  },
];

export interface PseudoCreateExtension {
  // quarantine type
  qt?: number,
}

const resetPseudoCreateExtension = (model: PseudoCreateExtension) => {
  model.qt = undefined;
}

export {
  resetPseudoCreateExtension,
  pseudoQuarantineMap,
};